import { useQueryClient } from '@tanstack/react-query'
import { useShallow } from 'zustand/react/shallow'

import { useGlobalStore } from '../../../store/global-store'
import type { LiveGuest } from '../../../types/lives/live'
import type { Response } from '../../../types/response'
import { useSub } from '../../subscription/use-sub'
import { LIVE_GUESTS_QUERY_KEY } from './use-get-live-guests'

const LIVE_POSITIONS = '/LIVE-POSITIONS'

/**
 * `useGuests` everything related to users in seat or not, the seats in general, are handled here
 * user joined, lefted, muted etc. User kicked, User points etc are handled by useGetLiveDetailPeople
 */
export const useGuests = () => {
  const queryClient = useQueryClient()

  const { liveId } = useGlobalStore(
    useShallow((state) => ({
      liveId: state.liveId,
    })),
  )

  /**
   *
   * This functions controls the guests data,
   * if audio is muted, here the audio is disable,
   * the same for video etc
   * this function also handles the join requesting/inviting by the host
   * if an user is requested to join seat, here is handled
   */
  const handleDataGuests = (liveInfo: LiveGuest[]) => {
    queryClient.setQueryData<Response<LiveGuest[]>>(
      [LIVE_GUESTS_QUERY_KEY, { liveId }],
      (old) => {
        const data = old as Response<LiveGuest[]>

        return {
          ...data,
          data: liveInfo,
        }
      },
    )
  }

  useSub<LiveGuest[]>({
    endpoint: `${LIVE_POSITIONS}/${liveId}`,
    skip: !liveId,
    // onData: handleDataGuests,
    onData: handleDataGuests,
  })
}
